export const savedSearchMessages = (scope: string) => ({
  createAlert: {
    id: `${scope}.savedSearch.createAlert`,
    defaultMessage: 'Create alert',
  },
  cantFind: {
    id: `${scope}.savedSearch.cantFind`,
    defaultMessage: 'Can’t find what you are looking for?',
  },
  createPersonalisedAlert: {
    id: `${scope}.savedSearch.createPersonalisedAlert`,
    defaultMessage: 'Create a personalised stock alert',
  },
  savedSearchStrapLine: {
    id: `${scope}.savedSearch.savedSearchStrapLine`,
    defaultMessage:
      'Be the first to know when cars that match your search criteria become available',
  },
  yourCriteria: {
    id: `${scope}.savedSearch.yourCriteria`,
    defaultMessage: 'Your search criteria:',
  },
  removeFromCriteria: {
    id: `${scope}.savedSearch.removeFromCriteria`,
    defaultMessage: 'remove from alert criteria',
  },
  savedSearchFormTitle: {
    id: `${scope}.savedSearch.savedSearchFormTitle`,
    defaultMessage: 'Enter email address to save this search. You can unsubscribe anytime.',
  },
  nativeSavedSearchFormTitle: {
    id: `${scope}.savedSearch.nativeSavedSearchFormTitle`,
    defaultMessage: 'Continue to save this search. You can unsubscribe anytime.',
  },
  savedSearchInputLabel: {
    id: `${scope}.savedSearch.savedSearchInputLabel`,
    defaultMessage: 'Enter email address',
  },
  savedSearchInputError: {
    id: `${scope}.savedSearch.savedSearchInputError`,
    defaultMessage: 'Please enter valid email to create alert',
  },
  savedSearchDisclaimer: {
    id: `${scope}.savedSearch.savedSearchDisclaimer`,
    defaultMessage:
      "We'll only use your email to send you search alerts, unless you're already subscribed to our marketing emails. You can turn off search alerts from any alert email. Your data will be processed in accordance with our",
  },
  nativeSavedSearchDisclaimer: {
    id: `${scope}.savedSearch.nativeSavedSearchDisclaimer`,
    defaultMessage:
      'You can turn off search alerts from any alert notification. Your data will be processed in accordance with our',
  },
  savedSearchSimpleDisclaimer: {
    id: `${scope}.savedSearch.savedSearchSimpleDisclaimer`,
    defaultMessage: 'By submitting, you agree to our',
  },
  nativeSavedSearchNotificationsMessage: {
    id: `${scope}.savedSearch.nativeSavedSearchNotificationsMessage`,
    defaultMessage: 'Notifications must be enabled to receive alerts.',
  },
  privacyPolicy: {
    id: `${scope}.savedSearch.privacyPolicy`,
    defaultMessage: 'privacy policy',
  },
  savedSearchSuccessHeadline: {
    id: `${scope}.savedSearch.savedSearchSuccessHeadline`,
    defaultMessage: 'Thanks!',
  },
  savedSearchSuccessSubhead: {
    id: `${scope}.savedSearch.savedSearchSuccessSubhead`,
    defaultMessage: 'Your search alert has been set up.',
  },
  savedSearchSuccessDesc: {
    id: `${scope}.savedSearch.savedSearchSuccessDesc`,
    defaultMessage:
      "We'll send you a fresh list of cars each week if we find ones you're looking for - so you won't miss out.",
  },
  savedSearchErrorHeadline: {
    id: `${scope}.savedSearch.savedSearchErrorHeadline`,
    defaultMessage: 'Sorry!',
  },
  savedSearchErrorSubhead: {
    id: `${scope}.savedSearch.savedSearchErrorSubhead`,
    defaultMessage: 'This search could not be saved.',
  },
  savedSearchErrorDesc: {
    id: `${scope}.savedSearch.savedSearchErrorDesc`,
    defaultMessage:
      'You have exceeded the number of saved searches available for this email address.',
  },
  backToSearch: {
    id: `${scope}.savedSearch.backToSearch`,
    defaultMessage: 'Back to search',
  },
  enableNotifications: {
    id: `${scope}.savedSearch.enableNotifications`,
    defaultMessage: 'Enable notifications',
  },
  signUp: {
    id: `${scope}.signUp.  `,
    defaultMessage: 'Sign up now',
  },
});
